export default __webpack_public_path__ + "static/media/repair-done.3da2db9b.jpg";